export const isAbsoluteUrl = (url: string) => {
  try {
    new URL(url);

    return true;
  } catch {
    return false;
  }
};
export const getCorrectPathAfterLogin = (url: string) => {
  if (isAbsoluteUrl(url)) {
    return url;
  } else {
    return url.startsWith('/') ? url : `/${url}`;
  }
};
